import { useTranslation } from '@frontend/i18n';
import { GenericFieldProps } from '../types';
import { Setting } from './setting';
import { TextDropdownField } from './text-dropdown-field';

type PaddingSettingItemProps = GenericFieldProps & {
  label: string;
  options: string[];
};

const PaddingSettingItem = ({ label, ...fieldProps }: PaddingSettingItemProps) => {
  return (
    <Setting.Item label={label}>
      <TextDropdownField label='' {...fieldProps} />
    </Setting.Item>
  );
};

const defaultPaddingOptions = ['0px', '8px', '16px', '24px', '32px', '80px'];
const defaultSpacingOptions = ['0px', '8px', '16px', '24px', '32px'];

type PaddingSettingProps = {
  imageSpacingFieldProps?: GenericFieldProps;
  paddingBottomFieldProps?: GenericFieldProps;
  paddingLeftFieldProps?: GenericFieldProps;
  paddingOptions?: string[];
  paddingRightFieldProps?: GenericFieldProps;
  paddingTopFieldProps?: GenericFieldProps;
  spacingOptions?: string[];
};

export const PaddingSetting = ({
  imageSpacingFieldProps,
  paddingBottomFieldProps,
  paddingLeftFieldProps,
  paddingOptions = defaultPaddingOptions,
  paddingRightFieldProps,
  paddingTopFieldProps,
  spacingOptions = defaultSpacingOptions,
}: PaddingSettingProps) => {
  const { t } = useTranslation('content-composer');

  return (
    <Setting title={t('Padding')}>
      {paddingTopFieldProps && (
        <PaddingSettingItem {...paddingTopFieldProps} label={t('Top')} options={paddingOptions} />
      )}
      {paddingBottomFieldProps && (
        <PaddingSettingItem {...paddingBottomFieldProps} label={t('Bottom')} options={paddingOptions} />
      )}
      {paddingLeftFieldProps && (
        <PaddingSettingItem {...paddingLeftFieldProps} label={t('Left')} options={paddingOptions} />
      )}
      {paddingRightFieldProps && (
        <PaddingSettingItem {...paddingRightFieldProps} label={t('Right')} options={paddingOptions} />
      )}
      {imageSpacingFieldProps && (
        <PaddingSettingItem {...imageSpacingFieldProps} label={t('Image Spacing')} options={spacingOptions} />
      )}
    </Setting>
  );
};
